/**
 * Acqs "New Deal" create sheet — partner picker controller.
 *
 * Extracted from `templates/acqs/_deal_create_sheet.html` (the inline block was
 * ~227 lines; anything over 100 belongs in a real module — `.claude/lessons/htmx.md`).
 *
 * The sheet is loaded over HTMX into the slide-over, so `DOMContentLoaded` has
 * long since fired by the time the markup exists. `sheets.js::populateSheet`
 * dispatches `sheet:ready` on the sheet element once the body is populated and
 * `htmx.process`ed — that is the init hook. `htmx:afterSettle` covers any other
 * path that swaps the form in, and the `dealPartnerControllerBound` dataset flag
 * makes a repeat init a no-op.
 *
 * All template-owned values reach this module through `data-` attributes on the
 * form (`data-partner-contacts-url`); nothing here needs Django context.
 */
(function () {
    var FORM_ID = 'create-deal-form';

    function initDealCreateForm() {
        // Only one sheet is open at a time, so the id is unambiguous document-wide;
        // the dataset flag makes every repeat call after the first a no-op.
        var form = document.getElementById(FORM_ID);
        if (!form || form.dataset.dealPartnerControllerBound) return;
        form.dataset.dealPartnerControllerBound = 'true';

        var typeGroup = document.getElementById('deal-partner-type-group');
        var typeahead = document.getElementById('deal-partner-typeahead');
        var partnerIdInput = document.getElementById('deal-partner-id');
        var sentByIdInput = document.getElementById('deal-sent-by-id');
        var partnerPanel = document.getElementById('deal-new-partner-panel');
        var pickerGeneration = 0;

        function selectionEl() {
            return document.getElementById('deal-partner-selection');
        }

        function setPanelVisible(panel, visible) {
            if (!panel) return;
            panel.hidden = !visible;
            panel.querySelectorAll('input, button').forEach(function (el) {
                el.disabled = !visible;
            });
            if (!visible) {
                panel.querySelectorAll('input').forEach(function (input) { input.value = ''; });
                var errors = panel.querySelector('[data-inline-create-errors]');
                if (errors) errors.innerHTML = '';
            }
            var guidance = panel.querySelector('[data-deal-inline-submit-guidance]');
            if (guidance) guidance.hidden = !visible;
            syncDealSubmit();
        }

        // This function owns `create-deal-submit` outright — it assigns
        // `disabled` rather than OR-ing into it — so the address gate has to be
        // one of its terms. The shared typeahead's `data-places-submit` opt-in
        // cannot be used here: closing the partner panel would run this and
        // overwrite the gate's decision. Same reason the lead and prospect
        // sheets fold `place_id` into their own `sync()`.
        function syncDealSubmit() {
            var submit = document.getElementById('create-deal-submit');
            if (!submit) return;
            var placeId = form.querySelector('input[name="place_id"]');
            // `placesUnitsPending` is the shared script's unit picker holding the
            // form until a rep picks (or dismisses) a unit at a multi-unit building.
            var addressReady = !!(placeId && placeId.value) && form.dataset.placesUnitsPending !== '1';
            submit.disabled = !addressReady || !!form.querySelector(
                '[data-deal-partner-panel]:not([hidden]), [data-deal-contact-panel]:not([hidden])'
            );
        }

        function invalidatePicker() {
            pickerGeneration += 1;
        }

        function resetSelection() {
            invalidatePicker();
            if (partnerIdInput) partnerIdInput.value = '';
            if (sentByIdInput) sentByIdInput.value = '';
            var selection = selectionEl();
            if (selection) {
                selection.innerHTML = '<div class="form-text">Search for a partner, or add a new one.</div>';
            }
        }

        function selectedPartnerType() {
            var input = typeGroup && typeGroup.querySelector('input[name="partner_type"]:checked');
            return input ? input.value : '';
        }

        function loadPartnerSelection(partnerId, sentById) {
            if (!partnerId || !window.htmx) return;
            var requestGeneration = ++pickerGeneration;
            if (partnerIdInput) partnerIdInput.value = partnerId;
            if (sentByIdInput) sentByIdInput.value = sentById || '';
            var url = form.getAttribute('data-partner-contacts-url');
            if (!url) return;
            var query = '?partner_id=' + encodeURIComponent(partnerId);
            if (sentById) query += '&sent_by_id=' + encodeURIComponent(sentById);
            query += '&deal_picker_request=' + encodeURIComponent(requestGeneration);
            window.htmx.ajax('GET', url + query, {target: '#deal-partner-selection', swap: 'outerHTML'});
        }

        function clearTypeaheadText() {
            if (!typeahead) return;
            var textInput = typeahead.querySelector('.typeahead-input');
            var results = typeahead.querySelector('.typeahead-results');
            if (textInput) textInput.value = '';
            if (results) { results.innerHTML = ''; results.classList.remove('show'); }
        }

        function showPartnerPanel(name) {
            resetSelection();
            if (typeahead) typeahead.hidden = true;
            setPanelVisible(partnerPanel, true);
            var nameInput = partnerPanel && partnerPanel.querySelector('[data-deal-partner-name]');
            var typeInput = partnerPanel && partnerPanel.querySelector('[data-deal-partner-create-type]');
            if (nameInput) { nameInput.value = name || ''; nameInput.focus(); }
            if (typeInput) typeInput.value = selectedPartnerType();
        }

        function hidePartnerPanel() {
            setPanelVisible(partnerPanel, false);
            if (typeahead) typeahead.hidden = false;
        }

        function clearPartnerState(clearSearch) {
            resetSelection();
            hidePartnerPanel();
            if (clearSearch) clearTypeaheadText();
        }

        function replaceTypeaheadForType(type) {
            if (!typeahead) return;
            var baseUrl = typeahead.getAttribute('data-typeahead-url').split('?')[0];
            var replacement = typeahead.cloneNode(true);
            replacement.setAttribute('data-typeahead-url', baseUrl + '?type=' + encodeURIComponent(type));
            var input = replacement.querySelector('.typeahead-input');
            var results = replacement.querySelector('.typeahead-results');
            if (input) input.value = '';
            if (results) { results.innerHTML = ''; results.classList.remove('show'); }
            typeahead.replaceWith(replacement);
            typeahead = replacement;
        }

        // Fired by `_places_address_typeahead_script.html` on every selection
        // and on the first keystroke that invalidates one.
        form.addEventListener('places:change', function () {
            syncDealSubmit();
        });

        form.addEventListener('typeahead:select', function (e) {
            var source = e.target.closest && e.target.closest('#deal-partner-typeahead');
            if (!source || !form.contains(source)) return;
            var detail = e.detail || {};
            if (detail.id) {
                hidePartnerPanel();
                loadPartnerSelection(detail.id, '');
            } else if (detail.name) {
                showPartnerPanel(detail.name);
            } else {
                clearPartnerState(false);
            }
        });

        form.addEventListener('input', function (e) {
            if (!e.target.matches('#deal-partner-typeahead .typeahead-input')) return;
            if ((partnerIdInput && partnerIdInput.value) || (sentByIdInput && sentByIdInput.value)) resetSelection();
        });

        form.addEventListener('htmx:beforeSwap', function (e) {
            var target = e.detail.target;
            if (!target || target.id !== 'deal-partner-selection') return;
            var path = e.detail.requestConfig && e.detail.requestConfig.path || '';
            var partnerMatch = path.match(/[?&]partner_id=([^&]+)/);
            var sentByMatch = path.match(/[?&]sent_by_id=([^&]+)/);
            var generationMatch = path.match(/[?&]deal_picker_request=([^&]+)/);
            var expectedSentById = sentByMatch ? decodeURIComponent(sentByMatch[1]) : '';
            if (!partnerMatch || !generationMatch || !partnerIdInput ||
                decodeURIComponent(partnerMatch[1]) !== partnerIdInput.value ||
                expectedSentById !== sentByIdInput.value ||
                generationMatch[1] !== String(pickerGeneration)) {
                e.detail.shouldSwap = false;
            }
        });

        form.addEventListener('htmx:afterSwap', function (e) {
            if (e.detail.target && e.detail.target.id === 'deal-partner-selection') syncDealSubmit();
        });

        form.addEventListener('change', function (e) {
            if (e.target.matches('input[name="partner_type"]')) {
                clearPartnerState(true);
                replaceTypeaheadForType(e.target.value);
                return;
            }
            if (e.target.matches('[data-deal-contact-choice]') && sentByIdInput) {
                sentByIdInput.value = e.target.value;
                invalidatePicker();
            }
        });

        form.addEventListener('click', function (e) {
            var partnerCancel = e.target.closest('[data-deal-partner-cancel]');
            if (partnerCancel) {
                e.preventDefault();
                clearPartnerState(false);
                return;
            }
            var addContact = e.target.closest('[data-deal-contact-add]');
            if (addContact) {
                e.preventDefault();
                setPanelVisible(selectionEl().querySelector('[data-deal-contact-panel]'), true);
                return;
            }
            var contactCancel = e.target.closest('[data-deal-contact-cancel]');
            if (contactCancel) {
                e.preventDefault();
                setPanelVisible(contactCancel.closest('[data-deal-contact-panel]'), false);
            }
        });

        form._dealPartnerController = {
            partnerCreated: function (detail) {
                hidePartnerPanel();
                clearTypeaheadText();
                loadPartnerSelection(detail.partnerId || detail.id, detail.sentById || '');
            },
            contactCreated: function (detail) {
                setPanelVisible(selectionEl().querySelector('[data-deal-contact-panel]'), false);
                loadPartnerSelection(detail.partnerId, detail.contactId || detail.id);
            },
        };

        // ── Next-action owner follows the deal assignee until manually overridden ──
        var assignee = document.getElementById('deal-assignee');
        var actionOwner = document.getElementById('deal-next-action-assignee');
        var ownerOverridden = form.querySelector('input[name="next_action_assignee_overridden"]');
        if (!assignee || !actionOwner || !ownerOverridden) return;

        function followAssignee() {
            if (ownerOverridden.value === '1') return;
            var selected = assignee.options[assignee.selectedIndex];
            actionOwner.value = selected ? selected.getAttribute('data-action-assignee-id') || '' : '';
        }

        assignee.addEventListener('change', followAssignee);
        actionOwner.addEventListener('change', function () {
            ownerOverridden.value = '1';
        });
        followAssignee();
    }

    // The inline-create endpoints fire these on `body`; the handlers reach the
    // live form through the controller it parked on itself, so a re-opened sheet
    // always talks to its own instance. Bound once at module load — this file is
    // in the bundle, which HTMX SPA navigation never re-executes.
    document.body.addEventListener('dealPartnerCreated', function (e) {
        var form = document.getElementById(FORM_ID);
        if (form && form._dealPartnerController) {
            form._dealPartnerController.partnerCreated(e.detail || {});
        }
    });

    document.body.addEventListener('dealPartnerContactCreated', function (e) {
        var form = document.getElementById(FORM_ID);
        if (form && form._dealPartnerController) {
            form._dealPartnerController.contactCreated(e.detail || {});
        }
    });

    document.body.addEventListener('sheet:ready', initDealCreateForm);
    document.body.addEventListener('htmx:afterSettle', initDealCreateForm);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDealCreateForm);
    } else {
        initDealCreateForm();
    }
}());
